import Vue from "vue";
import jwtDecode from "jwt-decode";

const hasRole = (role) => {
    const roles = JSON.parse(localStorage.getItem("roles")) || [];
    return roles.includes(role);
}

// const hasPerfil = (perfil) => {
//     const userToken = localStorage.getItem("token");
//     const tokenDecode = jwtDecode(userToken);
//     return tokenDecode.perfiles.some(p => p.nombre === perfil);
// };

const getPerfil = () => {
    const userToken = localStorage.getItem("token");
    const tokenDecode = jwtDecode(userToken);
    return tokenDecode.perfiles?.length ? tokenDecode.perfiles[0]?.nombre : null;
};

const getPerfiles = () => {
    const userToken = localStorage.getItem("token");
    const tokenDecode = jwtDecode(userToken);
    return tokenDecode.puesto?.perfiles?.map(p => p.nombre) || [];
};

const getPerfilesWithId = () => {
    const userToken = localStorage.getItem("token");
    const tokenDecode = jwtDecode(userToken);
    return tokenDecode.puesto?.perfiles?.map(p => ({ nombre: p.nombre, id: p.id })) || [];
};
const hasPerfil = (perfil) => {
    const userToken = localStorage.getItem("token");
    if (!userToken) return false;

    const tokenDecode = jwtDecode(userToken);

    const perfiles =
        tokenDecode.puesto?.perfiles?.length
            ? tokenDecode.puesto.perfiles
            : tokenDecode.perfiles;

    return perfiles?.some(p => p.nombre === perfil) ?? false;
};


Vue.prototype.hasRole = hasRole;
Vue.prototype.hasPerfil = hasPerfil;
Vue.prototype.getPerfil = getPerfil;
Vue.prototype.getPerfiles = getPerfiles;
Vue.prototype.getPerfilesWithId = getPerfilesWithId;

export {
    hasRole,
    hasPerfil,
    getPerfil,
    getPerfiles,
    getPerfilesWithId
}